import { Box, Link as MUILink } from '@mui/material';
import React from 'react';
import { PostExtraFields } from '@/utils/usePostExtraFields';

const ContactInformation = ({
  telephoneNumber,
  faxNumber,
  email,
  websiteUrl,
  informationRequestUrl,
}: PostExtraFields['contactInformation']) => {
  if (
    !(
      telephoneNumber ||
      faxNumber ||
      email ||
      websiteUrl ||
      informationRequestUrl
    )
  ) {
    return null;
  }
  return (
    <Box sx={{ h3: { pt: 2 } }}>
      {telephoneNumber && (
        <>
          <h3 id="telephone-number">Telephone Number</h3>
          <MUILink href={`tel:${telephoneNumber}`}>{telephoneNumber}</MUILink>
        </>
      )}
      {faxNumber && (
        <>
          <h3 id="fax-number">Fax Number</h3>
          <MUILink href={`tel:${faxNumber}`}>{faxNumber}</MUILink>
        </>
      )}
      {email && (
        <>
          <h3 id="email">Email</h3>
          <MUILink href={`mailto:${email}`}>{email}</MUILink>
        </>
      )}
      {websiteUrl && (
        <>
          <h3 id="website">Website</h3>
          <MUILink href={websiteUrl} rel="noopener sponsored" target="_blank">
            {websiteUrl}
          </MUILink>
        </>
      )}
      {informationRequestUrl && (
        <>
          <h3 id="information-request-url">Contact</h3>
          <MUILink
            href={informationRequestUrl}
            rel="noopener sponsored"
            target="_blank"
          >
            Request More Information
          </MUILink>
        </>
      )}
    </Box>
  );
};

export default ContactInformation;
